import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DIALOG_HIDE_CLASS } from '../../shared/constants';
import { IMarker } from '../../ranch-settings/interfaces';
import { RanchWeatherStationFormComponent } from '../../ranch-settings/shared/ranch-weather-station-form/main';

@Component({
	moduleId: module.id,
	selector: 'ranch-create-weather-station-dialog',
	templateUrl: 'weather-station-dialog.html'
})

export class RanchCreateWeatherStationDialog implements OnDestroy {
	@ViewChild(RanchWeatherStationFormComponent, { static: false })
	public weatherStationForm: RanchWeatherStationFormComponent;

	private _subscriptions$: Subject<boolean>;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { ranchCoordinates: string, selectedStationIds: number[] },
		public dialogRef: MatDialogRef<RanchCreateWeatherStationDialog>
	) {
		this._subscriptions$ = new Subject();

		this.dialogRef.backdropClick()
			.pipe(takeUntil(this._subscriptions$)).subscribe(() => {
				this.close();
			});
	}

	ngOnDestroy(): void {
		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public close(): void {
		if (!this.weatherStationForm) {
			this.dialogRef.close();
			return;
		}

		this.weatherStationForm.cancel();
	}

	public hide(): void {
		this.dialogRef.addPanelClass(DIALOG_HIDE_CLASS);
	}

	public show(): void {
		this.dialogRef.removePanelClass(DIALOG_HIDE_CLASS);
	}

	public submit(stations: IMarker[]): void {
		this.dialogRef.close(stations);
	}
}
